// extracted by mini-css-extract-plugin
export default {"container":"MW-z","title":"NW-z","link":"OW-z"};